<template>
    <Nav/>
    <div class="shadow-md p-4">
      <h1 class="text-3xl font-semibold">books</h1>
    </div>
    <div>
     
      <div class="ml-4 mt-6">
          <a href="" class="font-bold text-blue-300">Birna G. Konráðsdóttir</a><br>
  <p class="text-gray-500"> Hamingain I hullunum:Smasagnasafn (Icelandic Edition)</p>
  <h2 class="mt-3 mb-3 font-semibold">Icelandic Edition</h2>
  <img src="/bottomcard57.jpg" alt="" class="w-80 ml-7">
  </div>
  <div class="flex ml-3 mr-3 justify-between mt-16">
      <div class="border-4 px-10 py-1 text-center">
          <a href="">
          <p>Kindle</p>
          <p class="text-xl font-semibold">$9.99</p>
          <p>Available instantly</p>
      </a>
      </div>
      <div class="border-4 px-12 pt-3 border-green-700">
          <a href="">
          <p class="font-semibold">Paperback</p>
          <p class="text-amber-700 font-bold text-xl">$33.99</p>
      </a>
      </div>
  </div>
  <div class="mt-5 ml-5">
      <div class="text-4xl font-semibold"><sup>$</sup>6<sup>49</sup></div>
      <div><a href="" class="mt-5 text-blue-500 font-semibold">Deliver to Ethiopia</a></div>
      <h1 class="text-green-600 font-semibold mt-3">In Stock</h1>
      <select class="bg-slate-100 w-96 py-3 px-2 rounded-md border-2 border-gray-200 mt-3">
          <option value="">Quantity:1</option>
          <option value="">2</option>
          <option value="">3</option>
          <option value="">4</option>
          <option value="">5</option>
          <option value="">6</option>
          <option value="">7</option>
          <option value="">8</option>
          <option value="">9</option>
          <option value="">10</option>
      </select>
      <button class="mt-6 bg-yellow-300 rounded-3xl text-center px-36 font-semibold  py-3">Add to Cart</button>
      <button class="mt-3 bg-orange-400 rounded-3xl text-center px-36 ml-1 font-semibold  py-3">Buy Now</button>
  </div>
    </div>
    <div class="mt-10">
        <div class="bg-gray-600 text-white text-center py-2">
  <div><i class="fa-solid fa-caret-up"></i></div>
  <div class="text-sm">TOP OF PAGE</div>
        </div>
        <div class="bg-gray-800 flex pt-3 text-white pl-5 pb-6">
  <div>
    <div><a href="">Amazon.com</a></div>
    <div class="mt-5"><a href="">Your Lists</a></div>
    <div class="mt-5"><a href="">Registory & Gift List</a></div>
    <div class="mt-5"><a href="">Your Account</a></div>
    <div class="mt-5"><a href="">Sell Products on Amazon</a></div>
    <div class="mt-5"><a href="">Recalls and Product Safety <br> Alerts</a></div>
    <div class="mt-5"><a href="">Customer Service</a></div>
  
  </div>
  <div class="ml-5">
    <div><a href="">Your Orders</a></div>
    <div class="mt-5"><a href="">Gift Cards</a></div>
    <div class="mt-5"><a href="">Find a Gift</a></div>
    <div class="mt-5"><a href="">Browsing History</a></div>
    <div class="mt-5"><a href="">Your Returns</a></div>
  </div>
        </div>
        <div class="bg-gray-900 text-white pt-10 pb-10">
  <div class="flex ml-8">
  <div class="text-sm"><i class="fa-solid fa-globe"></i> English</div>
  <div class="text-sm ml-7">$ USD - US. Dollar</div>
  <div class="text-sm ml-7"><img src="/united.jpg" alt="" class="w-6 h-4 inline-block"> United States</div>
  </div>
  <div class="mt-10">
  <div class="text-center">
    Already a customer? <a href="">Sign in</a>
  </div>
  <div class="mt-5 flex text-xs ml-1 mr-1">
  <div><a href="" class="w-80">Conditions of Use</a></div>
  <div><a href="" class="ml-3">Privacy Notice</a></div>
  <div><a href="" class="ml-3">Consumer Health Data Privacy Disclosure</a></div>
  </div>
  <div class="text-center text-xs">Your Ads Privacy Choices <input type="checkbox" class="mt-2 ml-2"></div>
  <div class="text-center text-xs mt-3">&copy;1996-2024, Amazon.com, Inc. or its affiliates</div>
  </div>
        </div>
       </div>
  </template>
  
  <script>
  import Nav from '@/components/Nav'
  export default {
  components:{Nav}
  }
  </script>
  
  <style>
  
  </style>